import { PostModel } from '../data-layer/posts/types';

interface CardData {
    id: string;
    name: string;
    brand?: string;
}

export const trackView = (params: CardData) => {
    const tracked = sessionStorage.getItem(`${params.id}-view`);

    if (tracked) {
        return;
    }

    // @ts-ignore
    window.dataLayer.push({
        ecommerce: {
            detail: {
                products: [
                    {
                        id: params.id,
                        name: params.name,
                        brand: params.brand,
                    },
                ],
            },
        },
    });

    sessionStorage.setItem(`${params.id}-view`, params.id);
};

export const trackAddShoppingCard = (params: CardData) => {
    const tracked = sessionStorage.getItem(`${params.id}-in-shopping-card`);

    if (tracked) {
        return;
    }

    // @ts-ignore
    window.dataLayer.push({
        ecommerce: {
            add: {
                products: [
                    {
                        id: params.id,
                        name: params.name,
                        brand: params.brand,
                    },
                ],
            },
        },
    });

    sessionStorage.setItem(`${params.id}-in-shopping-card`, params.id);
};

interface TrackEcommerceEventParams {
    post: PostModel;
    trackEcommerceView?: boolean;
    trackEcommerceAdd?: boolean;
}

export const trackEcommerceEvent = (params: TrackEcommerceEventParams) => {
    const { post, trackEcommerceView, trackEcommerceAdd } = params;
    if (post.postType === 'post') {
        const ecommerceData = {
            id: post.id,
            name: post.text,
            brand: post.business?.displayName,
        };
        if (trackEcommerceView) {
            trackView(ecommerceData);
        }
        if (trackEcommerceAdd) {
            trackAddShoppingCard(ecommerceData);
        }
    }
};
